(function () {
  angular.module('kareo.ui.shared.directives.choose-kmb-document-dialog', [
    'flow',
    'kareo.ui.shared.directives.choose-document.reference-services', 'kareo.environment'])
    /**
     * Additional providers required:
     *
     * close: function to call when closing modal
     */
  .controller('ChooseKmbDocumentCtrl', chooseKmbDocumentCtrl);

  chooseKmbDocumentCtrl.$inject = ['close', 'AttachmentDocumentService',
    'practice', 'config', 'KareoEnvironment'];
  function chooseKmbDocumentCtrl(close, AttachmentDocumentService, practice, config, KareoEnvironment) {
    var kmbDocumentCtrl = this;
    kmbDocumentCtrl.attachState = 'choose';
    kmbDocumentCtrl.isModalDialog = config.isModalDialog;
    kmbDocumentCtrl.isInPm = KareoEnvironment.isInPm;
    var documentLabels = {
      2: {
        name: 'Explanation of Benefits',
        abbreviation: 'EOB',
        guideLineHeading: 'Your Payment batch should include:',
        guideLines: [
          'All paper payment correspondence (EOBs) from insurance and patients',
          'Copies of paper checks from insurance payers and patients',
          'Payment batch tally for the above items',
          'Refund Requests'
        ]
      },
      12: {
        name: 'Superbill Batch',
        abbreviation: 'CHG',
        guideLineHeading: 'Your Charge batch should include:',
        guideLines: [
          'All patient demographics (including copies of patient IDs, insurance cards, authorizations and referrals)',
          'All paper superbills or hospital rounds sheets',
          'Corresponding appointment or daily copay log'
        ]
      },
      29: {
        name: 'Copay Log',
        abbreviation: 'COPAY',
        guideLineHeading: 'Your Copay batch should include:',
        guideLines: [
          'Daily copay log (for practices submitting electronic charges and demographics)'
        ]
      },
      1123: {
        name: 'A/R',
        abbreviation: 'MISC',
        guideLineHeading: 'Your A/R batch should include:',
        guideLines: [
          'Any non-payment claim correspondence from insurance received through the mail',
          'Signed insurance settlement agreements',
          'Any request for medical record requests pertaining to an open claim'
        ]
      }
    };

    kmbDocumentCtrl.flowConfiguration = {
      flow: '', onSuccess($message) {
        return kmbDocumentCtrl.close(angular.fromJson($message));
      }, onFileError, onFileLoad(event) {
        kmbDocumentCtrl.uploadState = 'uploading';
        if (['EXE', 'APP', 'VB', 'SCR', 'MSI'].indexOf(event.getExtension().toUpperCase()) > -1) {
          return onFileError();
        }
        var file = event.file;
        if (file.size > 1024 * 1024 * 10) {
          return onFileError();
        }
        kmbDocumentCtrl.documentData.fileName = event.name;
        kmbDocumentCtrl.flowConfiguration.flow = event.flowObj;
        kmbDocumentCtrl.attachState = 'metadata';
        kmbDocumentCtrl.isdocumentFileNotSelected = false;
      }
    };

    kmbDocumentCtrl.documentLabels = documentLabels;
    kmbDocumentCtrl.uploadAndAttach = uploadAndAttach;
    kmbDocumentCtrl.close = close;
    kmbDocumentCtrl.labelChange = labelChange;

    init();

    var practiceInfo;
    practice.get().then((data) => {
      practiceInfo = data;
    });

    function init() {
      kmbDocumentCtrl.documentData = {
        documentStatus: 1,
        documentLabel: undefined,
        documentDate: moment().format('YYYY-MM-DD'),
        comment: '',
        fileName: '',
        documentName: ''
      };
      kmbDocumentCtrl.uploadState = undefined;
      kmbDocumentCtrl.flowConfiguration.flow = undefined;
    }

    function labelChange() {
      kmbDocumentCtrl.isdocumentLabelNotSelected = false;
    }

    function uploadAndAttach() {
      if (kmbDocumentCtrl.documentData.documentLabel && kmbDocumentCtrl.documentData.fileName) {
        kmbDocumentCtrl.uploadState = 'attaching';
        var documentName = getDocumentName(kmbDocumentCtrl.documentData.documentLabel,
           kmbDocumentCtrl.documentData.fileName);

        AttachmentDocumentService.uploadFile(kmbDocumentCtrl.flowConfiguration.flow.files[0].file,
        documentName, kmbDocumentCtrl.documentData.fileName,
        kmbDocumentCtrl.documentData.fileName,
        moment().startOf('day').valueOf(),
        kmbDocumentCtrl.documentData.documentStatus,
        kmbDocumentCtrl.documentData.documentLabel,
        (document) => {
          kmbDocumentCtrl.close({
            id: document.documentId, name: document.name
          });
          init();
        }, true);
      } else {
        kmbDocumentCtrl.isdocumentLabelNotSelected = !kmbDocumentCtrl.documentData.documentLabel;
        kmbDocumentCtrl.isdocumentFileNotSelected = !kmbDocumentCtrl.documentData.fileName;
      }
    }

    function getDocumentName(label, fileName) {
      return practiceInfo.name.substring(0, 3).toUpperCase() +
        practiceInfo.customerId + '-' +
        moment().format('MMDDYYYY') +
        documentLabels[label].abbreviation +
        (fileName.indexOf('.zip') > 0 ? '.zip' : '');
    }

    function onFileError() {
      kmbDocumentCtrl.uploadState = 'error';
    }
  }
})();
